module.exports = __webpack_public_path__ + "static/media/Relative-Bold-Web.6789495b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Bold-Web.woff2
// module id = 745
// module chunks = 0